export enum InteractionType {
    DISTRIBUTION = 'DISTRIBUTION',
    ADHOC_PHONE = 'ADHOC_PHONE',
    ADHOC_EMAIL = 'ADHOC_EMAIL',
    ADHOC_MESSAGE = 'ADHOC_MESSAGE',
    ADHOC_OTHER = 'ADHOC_OTHER',
    ADHOC_INBOUND_INQUIRY = 'ADHOC_INBOUND_INQUIRY',
}
